import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SUPER_SERVICEABLE_AREA,
    GET_ALL_SUPER_SERVICEABLE_AREAS,
    GET_SUPER_SERVICEABLE_AREA_REQUEST,
    CREATE_SUPER_SERVICEABLE_AREA,
    UPDATE_SUPER_SERVICEABLE_AREA,
    DELETE_SUPER_SERVICEABLE_AREA,
    CLEAR_SUPER_SERVICEABLE_AREA,
    SUPER_SERVICEABLE_AREA_ERROR,
    SUPER_SERVICEABLE_AREA_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all super serviceable areas
export const getSuperServiceableAreas = () => async dispatch => {
    try {
        dispatch({ type: SUPER_SERVICEABLE_AREA_LOADING });

        const res = await axios.get(`${API_URL}/super-serviceable-areas`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_SUPER_SERVICEABLE_AREAS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: SUPER_SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get super serviceable area by ID
export const getSuperServiceableArea = (id) => async dispatch => {
    try {
        dispatch({ type: GET_SUPER_SERVICEABLE_AREA_REQUEST });

        const res = await axios.get(`${API_URL}/super-serviceable-areas/${id}`);
        if(res.data.success){
            dispatch({
                type: GET_SUPER_SERVICEABLE_AREA,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        };
    } catch (err) {
        dispatch({
            type: SUPER_SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Create super serviceable area
export const createSuperServiceableArea = (formData) => async dispatch => {
    try {
        dispatch({ type: SUPER_SERVICEABLE_AREA_LOADING });

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const res = await axios.post(`${API_URL}/super-serviceable-areas`, formData, config);
        if(res.data.success){
            dispatch({
                type: CREATE_SUPER_SERVICEABLE_AREA,
                payload: res.data.data
            });
            dispatch(setAlert('Super serviceable area created successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        const errors = err.response?.data?.errors;

        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to create super serviceable area', 'danger'));
        }

        dispatch({
            type: SUPER_SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });

        throw err;
    }
};

// Update super serviceable area
export const updateSuperServiceableArea = (id, formData) => async dispatch => {
    try {
        dispatch({ type: SUPER_SERVICEABLE_AREA_LOADING });

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const res = await axios.put(`${API_URL}/super-serviceable-areas/${id}`, formData, config);

        dispatch({
            type: UPDATE_SUPER_SERVICEABLE_AREA,
            payload: res.data.data
        });
        if(res.data.success){
            dispatch(setAlert('Super serviceable area updated successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }

        return res.data;
    } catch (err) {
        const errors = err.response?.data?.errors;

        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to update super serviceable area', 'danger'));
        }

        dispatch({
            type: SUPER_SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });

        throw err;
    }
};

// Delete super serviceable area
export const deleteSuperServiceableArea = (id) => async dispatch => {
    try {
        dispatch({ type: SUPER_SERVICEABLE_AREA_LOADING });

        const res = await axios.delete(`${API_URL}/super-serviceable-areas/${id}`);

        dispatch({
            type: DELETE_SUPER_SERVICEABLE_AREA,
            payload: id
        });
        if(res.data.success){
            dispatch(setAlert('Super serviceable area deleted successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch({
            type: SUPER_SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });

        dispatch(setAlert('Failed to delete super serviceable area', 'danger'));
    }
};

// Clear super serviceable area
export const clearSuperServiceableArea = () => dispatch => {
    dispatch({ type: CLEAR_SUPER_SERVICEABLE_AREA });
};
